<template>
  <div
    v-if="isLoading"
    class="flex justify-center pb-2"
  >
    <wui-icon
      name="spinner"
    />
  </div>
  <ul
    v-else
    data-test="webcallback-order-list"
  >
    <li
      v-for="(callback, i) in actualCallbacks"
      :key="callback.guid"
      class="mb-4"
    >
      <div
        v-if="getShowDate(i, actualCallbacks)"
        class="m-2 border-b border-primary-tints-200 pb-2 text-1316 text-primary-tints-800"
      >
        {{ getDateString(callback) }}
      </div>

      <web-callback-order-item
        :callback="callback"
      />
    </li>
    <li
      v-for="(callback, i) in historyCallbacks"
      :key="callback.guid"
      class="mb-4"
    >
      <div
        v-if="getShowDate(i, historyCallbacks)"
        class="py-2 m-2 border-b border-primary-tints-300 text-1316 text-primary"
      >
        {{ getDateString(callback) }}
      </div>
      <web-callback-order-item
        :callback="callback"
        @delete-call-back="$emit('deleteCallBack', $event)"
      />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { WuiIcon } from '@wui/common-library'
import dayjs from 'dayjs'
import { computed } from 'vue'

import { CallBack } from '@/shared/types/api'
import { getMonthName, getDayOfWeekName } from '@/shared/utils/date-time'

import WebCallbackOrderItem from './web-callback-order-item.vue'

const props = withDefaults(defineProps<{
  list?: CallBack[],
  isLoading?: boolean
}>(), {
  list: () => [],
  isLoading: false,
})

defineEmits<{
  (event: 'deleteCallBack', value: CallBack['guid']): void;
}>()

const callbacks = computed(() => [...props.list].sort((a, b) => dayjs(a.datetime).tz().unix() - dayjs(b.datetime).tz().unix()))

const actualCallbacks = computed(() => callbacks.value.filter((callback) => dayjs(callback.datetime).tz().unix() > dayjs().tz().unix()))
const historyCallbacks = computed(() => callbacks.value.filter((callback) => dayjs(callback.datetime).tz().unix() < dayjs().tz().unix()))

const getDateString = (callback: CallBack) => {
  const date = dayjs(callback.datetime).tz()
  return `${date.format('D')} ${getMonthName(date.format('M'), 1) } ${date.format('YYYY')}, ${getDayOfWeekName(date.format('d'))}`
}

const getShowDate = (index: number, callbacks: CallBack[]) => {
  const prev = callbacks[index - 1]
  if (!prev) return true

  const current = callbacks[index]
  return dayjs(prev.datetime).tz().format('YYYY-MM-DD') !== dayjs(current?.datetime ?? '').tz().format('YYYY-MM-DD')
}
</script>
